const $ = jQuery;

class EmbedAspect {
	init() {
		$('.wp-block-embed iframe').each(function () {
			if ($(this).attr('width') && $(this).attr('height')) {
				$(this).css('aspect-ratio', $(this).attr('width') + ' / ' + $(this).attr('height'));
			}
		});
	}
}

export default new EmbedAspect();
